import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isEnableBanAllShareScreen } from '../../sharescreen-moderation/functions';
// import { isEnableBanAllWhiteboard } from '../../whiteboard-moderation/functions'
import { isEnableBanAll as isEnableBanAllChat } from '../../vtchat-moderation/functions';
import { isEnableBanAllUpload } from '../../vtfileupload-moderation/functions';
import { isEnableBanAllRaisehand } from '../../raisehand-moderation/functions';
import { isEnableBanAllPoll } from '../../poll-moderation/functions';
import { requestDisableAudioModeration, requestDisableVideoModeration, requestEnableAudioModeration, requestEnableVideoModeration } from '../../av-moderation/actions';
import { disableBanAllShareScreen, enableBanAllShareScreen } from '../../sharescreen-moderation/slice';
import { disableBanAllChat, enableBanAllChat } from '../../vtchat-moderation/slice';
import { disableBanAllUpload, enableBanAllUpload } from '../../vtfileupload-moderation/slice';
import { disableBanAllRaisehand, enableBanAllRaisehand } from '../../raisehand-moderation/slice';
import { disableBanAllPoll, enableBanAllPoll } from '../../poll-moderation/slice';
import { disableBanAllChangeName, enableBanAllChangeName } from '../../changename-moderation/slice';
import { disableBanAllRecording, enableBanAllRecording } from '../../recording-moderation/slice';
import { useEffect } from 'react';
import { isEnableBanAllChangeName } from '../../changename-moderation/functions';
import { isEnableBanAllRecording } from '../../recording-moderation/functions';
const useAllowParticipants = () => {
    const { roomConfiguration } = useSelector((state) => state['features/av-moderation']);
    const enableBanAllShareScreenState = useSelector((state) => isEnableBanAllShareScreen(state));
    // const enableBanAllWhiteboardState = useSelector(state => isEnableBanAllWhiteboard(state))
    const enableBanAllChatState = useSelector((state) => isEnableBanAllChat(state));
    const enableBanAllUploadState = useSelector((state) => isEnableBanAllUpload(state));
    const enableBanAllRaisehandState = useSelector((state) => isEnableBanAllRaisehand(state));
    const enableBanAllPollState = useSelector((state) => isEnableBanAllPoll(state));
    const enableBanAllChangeNameState = useSelector((state) => isEnableBanAllChangeName(state));
    const enableBanAllRecordingState = useSelector((state) => isEnableBanAllRecording(state));
    const dispatch = useDispatch();
    const onChangeCheck = (key, value) => {
        let _items = [...items];
        switch (key) {
            case 'audio':
                if (!value)
                    dispatch(requestEnableAudioModeration());
                else
                    dispatch(requestDisableAudioModeration());
                _items[0].values[0].checked = value;
                setItems(_items);
                break;
            case 'media':
                if (!value) {
                    // _items[0].values[2].disabled = true
                    dispatch(requestEnableVideoModeration());
                    // dispatch(enableBanAllShareScreen());
                }
                else {
                    // _items[0].values[2].disabled = false
                    dispatch(requestDisableVideoModeration());
                    // dispatch(disableBanAllShareScreen());
                }
                _items[0].values[1].checked = value;
                setItems(_items);
                break;
            case 'screenShare':
                if (!value)
                    dispatch(enableBanAllShareScreen());
                else
                    dispatch(disableBanAllShareScreen());
                _items[0].values[2].checked = value;
                setItems(_items);
                break;
            // case 'whiteboardCC':
            //     if (!value) dispatch(enableBanAllWhiteboard())
            //     else dispatch(disableBanAllWhiteboard())
            //     _items[0].values[3].checked = value
            //     setItems(_items)
            //     break
            case 'chat':
                if (!value) {
                    _items[1].values[1].disabled = true;
                    dispatch(enableBanAllChat());
                    dispatch(enableBanAllUpload());
                }
                else {
                    _items[1].values[1].disabled = false;
                    dispatch(disableBanAllChat());
                    // dispatch(disableBanAllUpload())
                }
                _items[1].values[0].checked = value;
                setItems(_items);
                break;
            case 'upload':
                if (!value)
                    dispatch(enableBanAllUpload());
                else
                    dispatch(disableBanAllUpload());
                _items[1].values[1].checked = value;
                setItems(_items);
                break;
            case 'raisehand':
                if (!value)
                    dispatch(enableBanAllRaisehand());
                else
                    dispatch(disableBanAllRaisehand());
                _items[1].values[2].checked = value;
                setItems(_items);
                break;
            case 'createPoll':
                if (!value)
                    dispatch(enableBanAllPoll());
                else
                    dispatch(disableBanAllPoll());
                _items[1].values[3].checked = value;
                setItems(_items);
                break;
            case 'changeName':
                if (!value)
                    dispatch(enableBanAllChangeName());
                else
                    dispatch(disableBanAllChangeName());
                _items[2].values[0].checked = value;
                setItems(_items);
                break;
            case 'recording':
                if (!value)
                    dispatch(enableBanAllRecording());
                else
                    dispatch(disableBanAllRecording());
                _items[2].values[1].checked = value;
                setItems(_items);
                break;
            default:
                break;
        }
    };
    const [items, setItems] = useState(() => {
        const state = APP.store.getState();
        return [
            {
                title: 'security.meetingInteraction',
                values: [
                    {
                        name: 'menuController.turnOnMicro',
                        key: 'audio',
                        checked: !roomConfiguration?.audio,
                        onChange: onChangeCheck
                    },
                    {
                        name: 'menuController.turnOnCamera',
                        key: 'media',
                        checked: !roomConfiguration?.media,
                        onChange: onChangeCheck
                    },
                    {
                        name: 'menuController.sharescreen',
                        key: 'screenShare',
                        checked: !isEnableBanAllShareScreen(state),
                        disabled: false,
                        onChange: onChangeCheck
                    },
                    // {
                    //     name: 'menuController.shareWhiteboard',
                    //     key: 'whiteboardCC',
                    //     checked: !isEnableBanAllWhiteboard(state),
                    //     onChange: onChangeCheck
                    // }
                ]
            },
            {
                title: 'security.messages',
                values: [
                    {
                        name: 'menuController.privateMessage',
                        key: 'chat',
                        checked: !isEnableBanAllChat(state),
                        onChange: onChangeCheck
                    },
                    {
                        name: 'menuController.upload',
                        key: 'upload',
                        checked: !isEnableBanAllUpload(state),
                        disabled: isEnableBanAllChat(state),
                        onChange: onChangeCheck
                    },
                    {
                        name: 'menuController.raisehand',
                        key: 'raisehand',
                        checked: !isEnableBanAllRaisehand(state),
                        onChange: onChangeCheck
                    },
                    {
                        name: 'menuController.createPoll',
                        key: 'createPoll',
                        checked: !isEnableBanAllPoll(state),
                        onChange: onChangeCheck
                    }
                ]
            },
            {
                title: 'security.others',
                values: [
                    {
                        name: 'menuController.changeName',
                        key: 'changeName',
                        checked: !isEnableBanAllChangeName(state),
                        onChange: onChangeCheck
                    },
                    {
                        name: 'menuController.recording',
                        key: 'recording',
                        checked: !isEnableBanAllRecording(state),
                        onChange: onChangeCheck
                    }
                ]
            }
        ];
    });
    useEffect(() => {
        let _items = [...items];
        _items[0].values[0].checked = !roomConfiguration.audio;
        setItems(_items);
    }, [roomConfiguration.audio]);
    useEffect(() => {
        let _items = [...items];
        _items[0].values[1].checked = !roomConfiguration.media;
        // _items[0].values[2].disabled = roomConfiguration.media
        setItems(_items);
    }, [roomConfiguration.media]);
    useEffect(() => {
        let _items = [...items];
        _items[0].values[2].checked = !enableBanAllShareScreenState;
        setItems(_items);
    }, [enableBanAllShareScreenState]);
    // useEffect(()=>{
    //     let _items = [...items]
    //     _items[0].values[3].checked = !enableBanAllWhiteboardState
    //     setItems(_items)
    // }, [enableBanAllWhiteboardState])
    useEffect(() => {
        let _items = [...items];
        _items[1].values[0].checked = !enableBanAllChatState;
        _items[1].values[1].disabled = enableBanAllChatState;
        setItems(_items);
    }, [enableBanAllChatState]);
    useEffect(() => {
        let _items = [...items];
        _items[1].values[1].checked = !enableBanAllUploadState;
        setItems(_items);
    }, [enableBanAllUploadState]);
    useEffect(() => {
        let _items = [...items];
        _items[1].values[2].checked = !enableBanAllRaisehandState;
        setItems(_items);
    }, [enableBanAllRaisehandState]);
    useEffect(() => {
        let _items = [...items];
        _items[1].values[3].checked = !enableBanAllPollState;
        setItems(_items);
    }, [enableBanAllPollState]);
    useEffect(() => {
        let _items = [...items];
        _items[2].values[0].checked = !enableBanAllChangeNameState;
        setItems(_items);
    }, [enableBanAllChangeNameState]);
    useEffect(() => {
        let _items = [...items];
        _items[2].values[1].checked = !enableBanAllRecordingState;
        setItems(_items);
    }, [enableBanAllRecordingState]);
    return {
        items
    };
};
export default useAllowParticipants;
